import React, { useEffect } from "react";
import Styles from "./BankingDetails.module.css";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { fetchDiscoms } from "../../../Redux/Slices/companyAdminSlice";
import { bankingDetails } from "../../../commons/Profile";
import { useDispatch, useSelector } from "react-redux";

const DetailElement = ({ detail, discomData, userData }) => {
  let actualValue;

  // Handle discom data from Redux store
  if (detail?.addressType === "discom" && discomData && discomData.length > 0) {
    actualValue = discomData[0][detail?.value];
  } else {
    actualValue =
      (userData && userData[detail?.value] != null
        ? userData[detail?.value]
        : null) ??
      (discomData && discomData[0] && discomData[0][detail?.value] != null
        ? discomData[0][detail?.value]
        : null) ??
      undefined;
  }

  let displayValue =
    actualValue !== undefined &&
    actualValue !== null &&
    actualValue !== "" &&
    actualValue !== "NA"
      ? actualValue
      : detail.defaultValue || "-";

  if (detail?.disp === "0") {
    return (
      <div className={Styles.eachDetailElement}>
        <div>{detail?.header}</div>
        <div>{displayValue}</div>
      </div>
    );
  }
  if (detail?.disp === "1") {
    return (
      <div className={Styles.eachDetailElement1}>
        <div>{detail?.header}</div>
        <div>{displayValue}</div>
      </div>
    );
  }
  if (detail?.disp === "2") {
    return (
      <div className={Styles.eachDetailElement}>
        <div>{detail?.header}</div>
        {actualValue ? (
          <div style={{ cursor: "pointer" }}>View</div>
        ) : (
          detail.defaultValue || "-"
        )}
      </div>
    );
  }
  return null;
};

const DetailSection = ({ item, discomData, userData }) => (
  <div className={Styles.eachDetailSection}>
    <div className={Styles.sectionHeading}>
      <span>{item?.heading}</span>
      {/* <DriveFileRenameOutlineIcon /> */}
    </div>
    <div className={Styles.eachDetailElementMainContainer}>
      {item?.details?.map((detail, idx) => (
        <DetailElement
          key={idx}
          detail={detail}
          discomData={discomData}
          userData={userData}
        />
      ))}
    </div>
  </div>
);

const BankingDetails = () => {
  const dispatch = useDispatch();
  const { discoms, loading, error } = useSelector(
    (state) => state.companyAdminSlice
  );
  const userData = useSelector((state) => state.persistedReducer);
  const userDetails = userData?.user?.user;

  useEffect(() => {
    dispatch(fetchDiscoms());
  }, [dispatch]);

  if (loading) {
    return (
      <div className={Styles.detailsContainer}>
        <div style={{ padding: "20px", textAlign: "center" }}>
          Loading banking details...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={Styles.detailsContainer}>
        <div style={{ padding: "20px", textAlign: "center", color: "red" }}>
          Error loading banking details: {error}
        </div>
      </div>
    );
  }

  return (
    <div className={Styles.detailsContainer}>
      {bankingDetails?.map((item, idx) => (
        <DetailSection
          key={idx}
          item={item}
          discomData={discoms}
          userData={userDetails}
        />
      ))}
    </div>
  );
};

export default BankingDetails;
